export const setAccountSession = (response) => {
  const account = response?.data?.account;

  if (!account) {
    console.error("Account data is missing:", response);
    return;
  }

  // Save whole object
  sessionStorage.setItem("user", JSON.stringify(account));

  // Save individual values
  sessionStorage.setItem("first_name", account.first_name || "");
  sessionStorage.setItem("last_name", account.last_name || "");
  sessionStorage.setItem("mobile", account.mobile || "");
  sessionStorage.setItem("pic", account.pic || "");
  sessionStorage.setItem("is_active", String(account.is_active));
  sessionStorage.setItem("groups", JSON.stringify(account.groups));
  sessionStorage.setItem("address", account.address || "");
  sessionStorage.setItem("city", account.city || "");
};


export function setAccessTkenSession(response) {
  sessionStorage.setItem("token", response);

}

export function logoutUser() {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user")
   sessionStorage.removeItem("first_name");
  sessionStorage.removeItem("last_name");
  sessionStorage.removeItem("mobile");
  sessionStorage.removeItem("pic");
  sessionStorage.removeItem("is_active");
  sessionStorage.removeItem("groups");
  sessionStorage.removeItem("address");
  sessionStorage.removeItem("city");
}

export const getAccountSession = () => {
  const data = sessionStorage.getItem("user");
  return data ? JSON.parse(data) : null;
};

export const clearAccountSession = () => {
  sessionStorage.removeItem("user");
};


export const getUserBasicDetails = () => {
  const userData = sessionStorage.getItem("user");

  if (!userData) return null;

  const user = JSON.parse(userData);

  return {
    first_name: user.first_name || "",
    last_name: user.last_name || "",
    mobile: user.mobile || "",
    pic: user.pic || "",

  };
};

export const setLanguageKey = (language) => {
  return sessionStorage.setItem("appLanguage", language)
}

export const setThemeMode = (them) => {
  return sessionStorage.setItem("themeMode", them)

}